import script from "./TabsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TabsComponent.vue?vue&type=script&setup=true&lang=js"

import "./TabsComponent.vue?vue&type=style&index=0&id=26ea5e12&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26ea5e12"]])

export default __exports__